<script lang="ts">
    import src from './svg/subdirectory_arrow_right_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;

    let style = 'transform: translate(20%, -10%);'; // make this arrow more below chekbox
</script>

<TemplateIcon {src} {scale} alt="" on:click {style} />
